<!--  -->
<template>
	<div class="policy">
		<div class="policy_mask" v-if="policyIndex == 3">
			<div class="mask_content">
				<div class="pay_btn" @click="payFunModel">
					<img src="https://file.jycyfww.com/wangchuang/qc/prod/static/img/32722103ecfb4ad7b60ec6c5d8b59bf9.png" alt="">
					开通VIP会员解锁全部内容
				</div>
				<p>解锁后可查看10,000+条深度政策解读</p>
			</div>
		</div>
		<div style="width: 1200px; margin: 0 auto">
			<div style="width: 100%; height: 40px"></div>
			<div style="
            width: 1200px;
            background: rgba(255, 255, 255, 1);
            margin: 0 auto;
          ">
				<div style="
              width: 1200px;
              height: 63px;
              border-bottom: 2px solid #3476c1;
              box-sizing: border-box;
            ">
					<div class="policy-tab" :style="policyIndex == 3
						? 'font-weight:500;font-size:22px;color:#fff;opacity:1;background-color: #3476C1;'
						: ''
						" @click="policyTab(3)">
						政策解读
					</div>
					<div class="policy-tab" :style="policyIndex == 1
						? 'font-weight:500;font-size:22px;color:#fff;opacity:1;background-color: #3476C1;'
						: ''
						" @click="policyTab(1)">
						政策动态
					</div>
					<div class="policy-tab" :style="policyIndex == 2
						? 'font-weight:500;font-size:22px;color:#fff;opacity:1;background-color: #3476C1;'
						: ''
						" @click="policyTab(2)">
						政策文件
					</div>

					<div style="
                float: right;
                height: 61px;
                line-height: 61px;
                display: flex;
              " @click="areaSelect()">
						<div style="
                  font-family: MicrosoftYaHei;
                  font-weight: 400;
                  color: #666666;
                  cursor: pointe;
                  position: relative;
                  cursor: pointer;
                ">
							地区选择：
							<div style="
                    width: 1920px;
                    height: 900px;
                    background: rgba(0, 0, 0, 0);
                    position: absolute;
                    z-index: 21;
                    right: -390px;
                    top: -300px;
                  " v-show="areaFlag == 2"></div>
							<div style="
                    width: 246px;
                    height: 346px;
                    background: rgba(255, 255, 255, 1);
                    box-shadow: 0px 10px 30px 0px rgba(153, 153, 153, 0.5);
                    border-radius: 20px;
                    position: absolute;
                    z-index: 10000;
                    right: -80px;
                    top: 43px;
                    opacity: 1;
                    padding-top: 30px;
                    padding-left: 30px;
                  " v-show="areaFlag == 2">
								<div style="
                      float: left;
                      color: #333333;
                      width: 52px;
                      height: 14px;
                      line-height: 14px;
                      font-size: 14px;
                      margin-bottom: 20px;
                      cursor: pointer;
                    " v-for="(item, index) in areaList" :key="index" @click="areaFn(index, item.code)" :style="areaIndex == index
											? 'font-weight:500;color:rgba(16,155,242,1);'
											: ''
											">
									{{ item.name }}
								</div>
							</div>
						</div>

						<div style="
                  margin-left: 5px;
                  margin-right: 10px;
                  font-size: 14px;
                  font-family: MicrosoftYaHei;
                  font-weight: 400;
                  color: #333333;
                  cursor: pointer;
                ">
							{{ areaList[this.areaIndex].name }}
						</div>
						<img src="@/static/home/arrow_down.png" alt="" style="
                  display: block;
                  width: 9px;
                  height: 5px;
                  margin: 28px 30px 0 10px;
                " />
					</div>
				</div>
				<div style="
              padding: 30px 0px 0 0px;
              display: flex;
              justify-content: space-between;
              flex-wrap: wrap;
            ">
					<div class="policy-i" style="overflow: hidden; margin-bottom: 23px; cursor: pointer"
						v-for="(item, index) in policyList" :key="index" @click="policyItem(item.id)">
						<div class="policy-i-l">{{ item.name }}</div>
						<div class="policy-i-r">
							{{ item.createDate.substring(0, 10) }}
						</div>
					</div>
				</div>
			</div>
			<!-- <div style="width:150px;height:40px;line-height:40px;text-align:center;background:rgba(0,0,0,1);border-radius:20px;margin:0 auto;font-size:14px;font-family:MicrosoftYaHei;font-weight:400;color:rgba(255,255,255,1);margin-top:40px;" @click="()=>{this.$router.push('/policy')}">更多政策</div> -->
			<div class="morezanserve" style="margin-bottom: 50px" @click="toMore('policy')">
				更多政策
			</div>
		</div>
		<el-dialog class="homepolicy_dialog" title="订单信息" @closed="modelClosed" :visible.sync="dialogVisible" width="640px">
			<div class="dialog_content">
				<div class="dialog_header">
					<div class="dh_bg">
						<div class="close_dialog" @click="dialogVisible = false"></div>
						<!-- 未登录状态 -->
						<div class="hn_login" v-if="noLoging">
							<div class="hn_logindom">
								<span @click="login">登录</span>/<span @click="register">注册</span>
							</div>
							<div class="hn_login_text">请登录后购买，享受会员权限</div>
						</div>
						<div class="h_login" v-else>
							<div class="h_logindom">
								<span>{{ account }}</span>
								<div><img
										src="https://file.jycyfww.com/wangchuang/qc/prod/static/img/665eccd80c0840bdb8c04986fe4bdd5c.png"
										alt=""></div>
							</div>
							<div class="h_login_text">升级VIP使用</div>
						</div>
					</div>
				</div>
				<div class="ad_content">
					<div class="ad_title">订单信息</div>
					<div class="ad_header">
						<div class="ad_h_item">
							<div class="ad_h_l">商品名称：</div>
							<div class="ad_h_r">{{ activeName }}</div>
						</div>
						<div class="ad_h_item">
							<div class="ad_h_l">订单编号：</div>
							<div class="ad_h_r">{{ payNo }}</div>
						</div>
						<div class="ad_h_item">
							<div class="ad_h_l">应付金额：</div>
							<div class="ad_h_r"><span>{{ payMoney }}</span></div>
						</div>
					</div>
					<div class="ad_pay">
						<div class="pay_way" v-if="!showPay">
							<div class="pay_way_tips">
								请选择支付方式：
							</div>
							<div class="pay_way_btns">
								<div class="pay_way_btn" @click="showPayFun(1)">
									<img src="https://file.jycyfww.com/wangchuang/qc/prod/static/img/80ec726e20ee41fc94bd6433c40b4a4a.png"
										alt=""><img
										src="https://file.jycyfww.com/wangchuang/qc/prod/static/img/6352f4eded7e4bfd9233ec56733243d3.png"
										class="hover" alt="">
									微信支付
								</div>
								<div class="pay_way_btn" @click="showPayFun(2)">
									<img src="https://file.jycyfww.com/wangchuang/qc/prod/static/img/45018c28151448a78b9139ef08c97020.png"
										alt=""><img
										src="https://file.jycyfww.com/wangchuang/qc/prod/static/img/e041631b962c4fa1ae20f028ab1dd55c.png"
										class="hover" alt="">
									银行转款
								</div>
							</div>
						</div>
						<div class="pay_in" v-else>
							<div class="pay_in_tips">
								收款方：启创未来（北京）科技有限公司
							</div>
							<div class="pay_code" v-if="payType == 1">
								<div class="code_img_box">
									<img class="code_img" :class="{ mosaic: noLoging }"
										src="https://file.jycyfww.com/other/static/data/c6ff8e1dae294f3386e6951182264bee.png" alt="">
									<div class="code_mask" v-if="noLoging">
										<div @click="login" class="mask_btn">点击登录扫码支付</div>
									</div>
									<div class="code_tips">开通前请阅读<span @click="openPdf">《会员服务协议》</span></div>
								</div>
								<div class="pay_code_tips">请使用微信扫码支付</div>
							</div>
							<div class="pay_other" v-if="payType == 2">
								<div class="poc_box">

									<div class="pay_other_content" :class="{ mosaic: noLoging }">
										<p class="big">对公汇款账户信息：</p>
										<p><span>公司名称：</span>启创未来(北京)科技有限公司</p>
										<p><span>开户银行：</span>中国民生银行股份有限公司北京上地支行</p>
										<p><span>银行账号：</span>617568885</p>
										<p class="color">* 汇款时请务必备注订单号，以便系统核销开通。</p>
										<p class="color">* 联系电话：010-82696524</p>
									</div>
									<div class="code_mask" v-if="noLoging">
										<div @click="login" class="mask_btn">点击登录扫码支付</div>
									</div>
								</div>
								<div class="pay_other_tips">汇款完成后预计 1-3 个工作日更新状态</div>
								<div class="pay_other_tips look">开通前请阅读<span @click="openPdf">《会员服务协议》</span></div>
							</div>
							<div class="pay_btn" @click="showPay = false">返回修改支付方式</div>
						</div>
					</div>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	data() {
		return {
			// areaList:['全国','北京','天津','河北','辽宁','吉林','黑龙江','山东','江苏','上海','浙江',' 安徽','福建','江西','广东','广西','海南','河南','湖南','湖北','山西','内蒙古','宁夏','青海','陕西','甘肃','新疆','四川','贵州','云南','重庆','西藏','香港','澳门','台湾'],
			areaList: [{}],
			policyIndex: 3, //政策
			areaFlag: 1,
			areaIndex: 0,
			policyList: [], //政策列表
			dialogVisible: false,
			payType: 1, // 1:微信支付 2:转账
			showPay: false,
			payNo: '',
			payMoney: '¥100.00',
			activeName: '12个月VIP会员费',
			noLoging: true,
			account: '',
			pdfUrl: 'https://file.jycyfww.com/jycyffw/file/%E5%B0%B1%E4%B8%9A%E5%88%9B%E4%B8%9A%E6%9C%8D%E5%8A%A1%E7%BD%91%E4%BC%9A%E5%91%98%E6%9C%8D%E5%8A%A1%E5%8D%8F%E8%AE%AE.pdf', // 会员服务协议
		};
	},

	components: {},

	computed: {},

	mounted() {
		this.isLogin()
		//政策列表
		this.$axios
			.post("/v1/cloud/common/policy", {
				pageSize: 20,
				provinceCode: 0,
			})
			.then(({ data }) => {
				if (data) {
					data.forEach(item => {
						item.createDate = this.formmaterTime(item.createDate)
					})
					this.policyList = data;
				}
			})
			.catch((error) => {
				console.log(error);

				this.$message.error(error.response.data.message);
			});
		//地区名列表
		this.$axios
			.get("/v1/cloud/common/policy/area")
			.then(({ data }) => {
				if (data) {
					this.areaList = data;
				}
			})
			.catch((error) => {
				this.$message.error(error.response.data.message);
			});
	},

	methods: {
		openPdf() {
			window.open(this.pdfUrl);
		},
		// 判断是否登录
		isLogin() {
			if (localStorage.token) {
				this.noLoging = false
				this.account = localStorage.getItem('account')
			} else {
				this.noLoging = true
				this.account = ''
			}
		},
		login() {
			this.$router.push({
				path: '/login',
			})
		},
		register() {
			this.$emit('event', false);
			this.$router.push({
				path: '/register',
			})
		},
		// 修改支付方式
		showPayFun(type) {
			this.payType = type
			this.showPay = true
		},
		// 付款弹窗
		payFunModel() {
			this.isLogin()
			this.payNo = `ORD${new Date().getTime()}`
			this.dialogVisible = true
		},
		// 付款弹窗关闭
		modelClosed() {
			this.showPay = false
		},
		padZero(n) {
			return n > 9 ? n : '0' + n
		},
		// 时间格式化
		formmaterTime(time) {
			const dt = new Date(time)
			const y = dt.getFullYear()
			const m = this.padZero(dt.getMonth() + 1)
			const d = this.padZero(dt.getDate())
			return `${y}-${m}-${d}`
		},
		areaFn(s, code) {
			this.areaIndex = s;
			//政策列表
			this.$axios
				.post("/v1/cloud/common/policy", {
					pageSize: 20,
					provinceCode: code,
				})
				.then(({ data }) => {
					if (data) {
						data.forEach(item => {
							item.createDate = this.formmaterTime(item.createDate)
						})
						this.policyList = data;
					}
				})
				.catch((error) => {
					this.$message.error(error.response.data.message);
				});
		},
		areaSelect() {
			if (this.areaFlag == 1) {
				this.areaFlag = 2;
			} else if (this.areaFlag == 2) {
				this.areaFlag = 1;
			}
		},
		policyItem(id) {
			sessionStorage.setItem("tabIndex", 2);
			this.$router.push({
				path: "/policyDetail",
				query: {
					id,
				},
			});
		},
		policyTab(s) {
			this.policyIndex = s;
		},
	}
}

</script>
<style lang='less' scoped>
.policy {
	width: 100%;
	height: fit-content;
	background: rgba(255, 255, 255, 1);
	position: relative;

	.policy_mask {
		position: absolute;
		left: 0;
		top: 100px;
		width: 100%;
		height: calc(100% - 100px);
		background: linear-gradient(180deg, rgba(255, 255, 255, .2) 0%, #FFFFFF 50%);
		display: flex;
		align-items: center;
		justify-content: center;

		.mask_content {

			.pay_btn {
				display: flex;
				align-items: center;
				justify-content: center;
				cursor: pointer;
				user-select: none;
				width: 300px;
				height: 50px;
				background: linear-gradient(90deg, #FFA72F 0%, #EF6C00 100%);
				box-shadow: 0px 2px 8px 0px rgba(240, 109, 1, 0.5);
				border-radius: 10px 10px 10px 10px;
				font-family: PingFang SC;
				font-weight: 600;
				font-size: 18px;
				color: #FFFFFF;
				line-height: 18px;
				column-gap: 9px;

				img {
					width: 41px;
					height: 30px;
					display: block;
				}
			}

			p {
				text-align: center;
				margin-top: 14px;
				font-family: PingFang SC;
				font-weight: 400;
				font-size: 14px;
				color: #0077C7;
				line-height: 14px;
			}
		}

	}

	.morezanserve {
		margin: 20px auto 0;
		width: 150px;
		height: 40px;
		border: 1px solid #5fc0e4;
		border-radius: 3px;
		line-height: 40px;
		color: #5fc0e4;
		box-sizing: border-box;
		text-indent: 34px;
		background-image: url("../../static/common/morezan.png");
		background-size: 15px 15px;
		background-repeat: no-repeat;
		background-position: 101px 12px;
		cursor: pointer;
	}

	.morezanserve:hover {
		background-color: #5fc0e4;
		background-image: url("../../static/common/morezan1.png");
		color: #fff;
	}

	.policy-tab {
		width: 138px;
		height: 63px;
		line-height: 63px;
		font-size: 22px;
		font-family: MicrosoftYaHei;
		font-weight: 400;
		color: #3476c1;
		text-align: center;
		float: left;
		cursor: pointer;
	}

	.policy-i {
		width: 560px;
		height: 15px;
		line-height: 15px;
		font-size: 14px;
		font-family: MicrosoftYaHei;
		font-weight: 400;
		margin-bottom: 20px;

		.policy-i-l {
			color: rgba(51, 51, 51, 1);
			float: left;
			width: 420px;
			overflow: hidden;
			padding-left: 15px;
			text-overflow: ellipsis;
			white-space: nowrap;
			background-image: url("../../static/home/policybgi.png");
			background-size: 5px 5px;
			background-repeat: no-repeat;
			background-position: 0 5px;
		}

		.policy-i-r {
			color: rgba(153, 153, 153, 1);
			float: right;
		}
	}

	.policy-i:hover .policy-i-l {
		font-weight: 500;
		color: #3476c1;
	}

	.policy-i:hover .policy-i-r {
		font-weight: 500;
		color: #3476c1;
	}
}
</style>
<style lang="less">
.homepolicy_dialog {
	.el-dialog {
		border-radius: 3px;
		box-shadow: none;
	}

	.el-dialog__header {
		display: none;
	}

	.el-dialog__body {
		padding: 0 0 40px;
	}

	.dialog_content {
		width: 100%;
	}

	.dialog_header {
		width: 100%;
		height: 70px;
		border-radius: 3px 3px 3px 3px;
		background: linear-gradient(90deg, #4F98EC 0%, #1E6FCA 100%);

		.dh_bg {
			width: 100%;
			height: 100%;
			background-image: url('https://file.jycyfww.com/wangchuang/qc/prod/static/img/59854e76e0bf412ea4c2708af3038e45.png');
			background-size: cover;
			background-repeat: no-repeat;
			position: relative;

			.close_dialog {
				width: 24px;
				height: 24px;
				background-image: url('https://file.jycyfww.com/wangchuang/qc/prod/static/img/47bf755667294be8b285bc0f90c7bfe4.png');
				background-size: 14px 14px;
				background-repeat: no-repeat;
				cursor: pointer;
				user-select: none;
				background-position: center;
				position: absolute;
				top: 18px;
				right: 25px;
			}

			.hn_login {
				height: 60px;
				padding-left: 30px;
				display: flex;
				align-items: center;
				column-gap: 10px;

				.hn_logindom {
					display: flex;
					align-items: center;
					font-family: PingFang SC-Semibold;
					font-weight: 600;
					font-size: 18px;
					color: #FFFFFF;
					line-height: 18px;

					span {
						cursor: pointer;
						user-select: none;
					}
				}

				.hn_login_text {
					font-family: PingFang SC;
					font-weight: 400;
					font-size: 14px;
					color: rgba(255, 255, 255, 0.8);
					line-height: 14px;
				}
			}

			.h_login {
				display: flex;
				padding-left: 30px;
				height: 60px;
				align-items: center;
				column-gap: 20px;

				.h_logindom {
					display: flex;
					align-items: center;
					font-family: PingFang SC-Semibold;
					font-weight: 600;
					font-size: 18px;
					color: #FFFFFF;
					line-height: 18px;
					column-gap: 4px;

					div {
						width: 42px;
						height: 16px;
						background: #AFD4FF;
						border-radius: 3px 3px 3px 3px;
						display: flex;
						align-items: center;
						justify-content: center;

						img {
							width: 37px;
							height: 10px;
							display: block;
						}
					}
				}

				.h_login_text {
					font-family: PingFang SC;
					font-weight: 400;
					font-size: 14px;
					color: rgba(255, 255, 255, 0.8);
					line-height: 14px;
				}
			}
		}
	}

	.ad_content {
		margin-top: -10px;
		width: 100%;
		padding: 10px 30px 0;
		background: #fff;
		position: relative;

		.ad_title {
			width: 100%;
			height: 80px;
			font-family: PingFang SC;
			font-weight: 600;
			font-size: 20px;
			color: #333333;
			line-height: 20px;
			display: flex;
			align-items: center;
			justify-content: center;
		}

		.ad_header {
			width: 100%;
			box-sizing: border-box;
			padding: 20px;
			background: #F9F9F9;
			border-radius: 3px 3px 3px 3px;

			.ad_h_item {
				height: 14px;
				display: flex;
				align-items: center;
				justify-content: space-between;
				font-family: PingFang SC;
				font-weight: 400;
				font-size: 14px;
				color: #666666;
				line-height: 14px;

				.ad_h_r {
					span {
						color: #D33535;
					}
				}

			}

			.ad_h_item+.ad_h_item {
				margin-top: 24px;
			}
		}

		.ad_pay {
			margin-top: 24px;
			border-top: 1px solid #EEEEEE;
			padding-top: 24px;

			.pay_way {
				.pay_way_tips {
					height: 14px;
					font-family: PingFang SC;
					font-weight: 400;
					font-size: 14px;
					color: #333333;
					line-height: 14px;
				}

				.pay_way_btns {
					margin-top: 24px;
					display: flex;
					justify-content: center;
					align-items: center;
					column-gap: 30px;

					.pay_way_btn {
						width: 150px;
						height: 40px;
						border-radius: 3px 3px 3px 3px;
						border: 1px solid #EEEEEE;
						box-sizing: border-box;
						display: flex;
						justify-content: center;
						align-items: center;
						column-gap: 5px;
						cursor: pointer;
						user-select: none;

						img {
							display: block;
							width: 20px;
							height: 20px;
						}

						.hover {
							display: none;
						}

						&:hover {
							background: #5FC0E4;
							border-color: #5FC0E4;
							color: #fff;

							img {
								display: none;
							}

							.hover {
								display: block;
							}
						}
					}
				}
			}

			.pay_in {
				.pay_in_tips {
					font-family: PingFang SC;
					font-weight: 400;
					font-size: 14px;
					color: #999999;
					line-height: 14px;
					margin-left: 20px;
				}

				.pay_code {
					margin-top: 30px;

					.code_img_box {
						width: 130px;
						height: 130px;
						margin: 0 auto;
						position: relative;
					}

					.code_tips {
						position: absolute;
						font-family: PingFang SC;
						font-weight: 400;
						font-size: 14px;
						color: #666;
						line-height: 14px;
						margin-top: 10px;
						white-space: nowrap;
						left: calc(100% + 15px);

						span {
							cursor: pointer;
							user-select: none;
							color: #0077C7;
						}
					}

					.code_img {
						display: block;
						width: 130px;
						height: 130px;
					}

					.pay_code_tips {
						margin-top: 10px;
						font-family: PingFang SC;
						font-weight: 400;
						font-size: 14px;
						color: #333333;
						line-height: 14px;
						text-align: center;
					}
				}

				.pay_other {
					margin-top: 24px;
					width: 100%;
					padding: 0 20px;
					box-sizing: border-box;

					.poc_box {
						position: relative;
					}

					.pay_other_content {
						width: 100%;
						padding: 20px;
						box-sizing: border-box;
						background: rgba(211, 53, 53, 0.05);
						border-radius: 3px 3px 3px 3px;
						font-family: PingFang SC;
						font-weight: 400;
						font-size: 14px;
						line-height: 21px;

						.big {
							color: #333333;
						}

						p {
							color: #666;

							span {
								color: #999;
							}
						}

						.color {
							color: #D33535;
							font-size: 12px;
						}
					}

					.pay_other_tips {
						text-indent: 20px;
						font-family: PingFang SC;
						font-weight: 400;
						font-size: 12px;
						color: #999999;
						line-height: 12px;
						margin-top: 10px;

						&.look {
							font-size: 14px;
							color: #666;

							span {
								cursor: pointer;
								user-select: none;
								color: #0077C7;
							}
						}
					}
				}

				.pay_btn {
					display: flex;
					align-items: center;
					justify-content: center;
					width: 150px;
					height: 40px;
					border-radius: 3px 3px 3px 3px;
					border: 1px solid #3476C1;
					font-family: PingFang SC;
					font-weight: 400;
					font-size: 14px;
					color: #3476C1;
					box-sizing: border-box;
					margin: 30px auto 0;
					cursor: pointer;
					user-select: none;
				}
			}
		}
	}
}

.code_mask {
	background: rgba(0, 0, 0, 0.15);
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;

	.mask_btn {
		width: 110px;
		height: 30px;
		background: #3476C1;
		border-radius: 3px 3px 3px 3px;
		cursor: pointer;
		user-select: none;
		display: flex;
		align-items: center;
		justify-content: center;
		font-family: PingFang SC;
		font-weight: 400;
		font-size: 12px;
		color: #FFFFFF;
		line-height: 12px;
	}
}

.mosaic {
	filter: blur(4px) !important;
}
</style>